import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShieldCheck"><Path fillRule="evenodd" clipRule="evenodd" d="M3 5.03613L12 1.94238L21 5.03613V11.9122C21 14.7189 19.8511 16.7416 18.1875 18.3166C16.6151 19.8052 14.5552 20.916 12.6319 21.9531L12 22.294L11.3681 21.9531C9.44484 20.916 7.38493 19.8053 5.8125 18.3166C4.14891 16.7416 3 14.7189 3 11.9122V5.03613ZM15.9142 9.75L14.5 8.33579L11 11.8358L9.5 10.3358L8.08579 11.75L11 14.6642L15.9142 9.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShieldCheck;
